import { FormInputProps } from '@usacsmideo/types';

export const FormInput = (props: FormInputProps) => {
  return (
    <div className="my-2 mr-4 flex flex-row text-xl font-bold">
      <label>
        {props.label}
        <input
          id={props.id}
          name={props.name}
          value={props.value}
          onBlur={props.handleBlur}
          onChange={props.handleChange}
          autoComplete={props.autoComplete ? props.autoComplete : 'off'}
          placeholder={props.placeholder ? props.placeholder : ''}
          type={props.type ? props.type : 'text'}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-lg text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
        />
      </label>
    </div>
  );
};
